//Create a page to add, update and delete services
import React from 'react';
import { useNavigate } from 'react-router-dom';
import NewServiceForm from './NewServiceForm';

const ManageService = (props) => {

  return (
    <div className="">

    </div>
  );
}

export default ManageService;